export default __webpack_public_path__ + "static/media/emergency.5b6088a5.md";